<div class="emtconfiguration_tree">
    <div class="EmtConfiguration">
        <div style="position:relative">
            <div class="panel-body">
                <div class="row">
                    <div class="edituser panel-body zoomIn col-md-3 col-sm-12">
                        <otasettings-levels (levelSelectedTrigger)="onNewLevelSelected($event)" [maxDepth]="2"></otasettings-levels>
                    </div>
                    <div class="panel-body zoomIn col-md-9 col-sm-12">
                        <otasettings-list></otasettings-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

